import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    Output,
} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AbstractValueAccessor} from '../abstract/value-accessor.abstract';

@Component({
    selector: 'lta-switch',
    templateUrl: 'switch.component.html',
    styleUrls: ['switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SwitchComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchComponent extends AbstractValueAccessor<boolean> {
    @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>()

    @Input() withLabel: boolean = false
    @Input() skipAnimation: boolean = false

    updateAndEmitToggle() {
        this.updateValue(!this.value)
        if (!this.disabled) {
            this.onToggle.emit(this.value)
        }
    }
}
